import { render, staticRenderFns } from "./PerformanceLegend.vue?vue&type=template&id=68b98988&scoped=true"
import script from "./PerformanceLegend.vue?vue&type=script&lang=js"
export * from "./PerformanceLegend.vue?vue&type=script&lang=js"
import style0 from "./PerformanceLegend.vue?vue&type=style&index=0&id=68b98988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b98988",
  null
  
)

export default component.exports